// ======================================================================
// TransportRoutes.js
// ======================================================================

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import TransportPage from "../pages/TransportPage";
import TransportDetailPage from "../pages/TransportDetailPage";
import TransportDashboard from "../pages/TransportDashboard";

export default function TransportRoutes() {
  return (
    <Routes>

      {/* Dashboard */}
      <Route path="dashboard" element={<TransportDashboard />} />

      {/* List */}
      <Route path="list" element={<TransportPage />} />

      {/* Detail */}
      <Route path="list/:transportId" element={<TransportDetailPage />} />

      {/* Default redirect (RELATIVE — IMPORTANT) */}
      <Route path="*" element={<Navigate to="list" replace />} />

    </Routes>
  );
}
